import { render, staticRenderFns } from "./Keijiban.vue?vue&type=template&id=a3a285b2&scoped=true&"
import script from "./Keijiban.vue?vue&type=script&lang=js&"
export * from "./Keijiban.vue?vue&type=script&lang=js&"
import style0 from "./Keijiban.vue?vue&type=style&index=0&id=a3a285b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3a285b2",
  null
  
)

export default component.exports